// pdf.js is half a megabyte of module-init work that only PDF-rendering pages need, so
// it stays out of the entry bundles: webpack splits this `import()` into its own chunk,
// fetched the first time a page actually loads a PDF. Repeated calls reuse the same
// module, so the worker setup runs once no matter how many controllers ask.
export async function loadPdfjs() {
  const pdfjsLib = await import("pdfjs-dist")
  // Matches pdfjs-dist@3.11.174.
  pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js"
  return pdfjsLib
}
